export const julyAbbreviatedLowercase = "M$U2zb";
export default {julyAbbreviatedLowercase};